import Drawer from '@mui/material/Drawer';
import navConfig from '../NavConfig';
import SidebarHeader from './SidebarHeader';
import SidebarNavigation from './SidebarNavigation';
import DocumentationHelper from './DocumentationHelper';
import { DRAWER_WIDTH } from '../index';
import DownloadsSidebar from './DownloadsSidebar';
import Scrollbar from '../../../components/Scrollbar';

const PortalSidebar = () => (
  <Drawer
    open
    variant="persistent"
    PaperProps={{
      sx: {
        width: DRAWER_WIDTH,
        bgcolor: '#272727',
        borderRightStyle: 'dashed',
      },
    }}>
    <Scrollbar>
      <SidebarHeader />
      <SidebarNavigation sidebarNavigationList={navConfig} />
      <DownloadsSidebar />
      <DocumentationHelper />
    </Scrollbar>
  </Drawer>
);

export default PortalSidebar;
